const IsInViewport = function(element, position) {
  if (element) {
    const rect = element.getBoundingClientRect()
    const top = parseInt(rect.top, 10)
    const height = parseInt(rect.height, 10)

    // The center of the element is in viewport
    if (!position || position === 1) {
      return top + height / 2 - window.innerHeight < 0
    } else if (position && position === 0) {
      // At least one pixel is in viewport
      return top - window.innerHeight < 0
    } else if (position && position === 2) {
      // The bottom of the element is in viewport
      return top + height - window.innerHeight < 0
    } else if (position && position === 3) {
      // The top of the element is 100 px from being in the viewport
      return top - 100 - window.innerHeight < 0
    }
  }
}

export { IsInViewport as default }
